<script>
    import Option from '../Option.svelte';
    import { _ } from 'svelte-i18n';
    import { DateTime } from 'luxon';

    let { value = [], date = null, availableTimeframes = [], onChange = () => {} } = $props();

    let morning = $state(value.includes('morning'));
    let afternoon = $state(value.includes('afternoon'));
    let evening = $state(value.includes('evening'));

    const cutoffHours = {
        morning: 12,
        afternoon: 18,
        evening: 22,
    };

    function isDisabled(timeframe) {
        if (!date) return false;
        const now = DateTime.now();
        if (date !== now.toISODate()) return false;
        return now.hour >= cutoffHours[timeframe];
    }

    let morningDisabled = $derived(isDisabled('morning'));
    let afternoonDisabled = $derived(isDisabled('afternoon'));
    let eveningDisabled = $derived(isDisabled('evening'));

    $effect(() => {
        if (morningDisabled && morning) morning = false;
        if (afternoonDisabled && afternoon) afternoon = false;
        if (eveningDisabled && evening) evening = false;
    });

    $effect(() => {
        const selected = [];
        if (morning) selected.push('morning');
        if (afternoon) selected.push('afternoon');
        if (evening) selected.push('evening');
        onChange(selected);
    });
</script>

<div class="timeframe">
    <p>{$_('waitlist_timeframe_question')}</p>

    <div class="options">
        {#if availableTimeframes.includes('morning')}
            <Option bind:checked={morning} disabled={morningDisabled}>
                {$_('waitlist_morning')}
            </Option>
        {/if}

        {#if availableTimeframes.includes('afternoon')}
            <Option bind:checked={afternoon} disabled={afternoonDisabled}>
                {$_('waitlist_afternoon')}
            </Option>
        {/if}

        {#if availableTimeframes.includes('evening')}
            <Option bind:checked={evening} disabled={eveningDisabled}>
                {$_('waitlist_evening')}
            </Option>
        {/if}
    </div>
</div>

<style>
    .timeframe {
        margin-bottom: 1.5em;
    }

    p {
        margin: 0 0 1em 0;
        font-size: 0.95em;
    }

    .options {
        display: flex;
        flex-direction: column;
        gap: 0.5em;
    }
</style>
